import React from "react";
import { CreateQuizUrl } from "../../libs/env";

const EditButton = ({label, ...props}) => {
    let params = new URL(document.location).searchParams;
    let edit_template = params.get("edit_template")
    return (
        <>
        {!edit_template &&(
            <div>
            {window.location.pathname.includes(CreateQuizUrl)? (
                <button class="btn btn-darkblue px-3 py-0 no-download" type="button" disabled>
                    {label}
                </button>
            ):(
                <button class="btn btn-darkblue px-3 py-0 no-download" type="button" {...props}>
                    {label}
                </button>
            )}
            </div>
        )}
        </>
      );
    // label && isSaving ? (
    //     <button class="btn border-primary text-primary fw-bold btn-md float-end btn-width" type="button" disabled>
    //       <span
    //         class="spinner-border spinner-border-sm me-2"
    //         role="status"
    //         aria-hidden="true"
    //       ></span>
    //       Checking
    //     </button>
    //   ) : isSubmitting ? (
    //     <button class="btn btn-warning btn-md float-end btn-width" type="button" disabled>
    //       <span
    //         class="spinner-border spinner-border-sm me-2"
    //         role="status"
    //         aria-hidden="true"
    //       ></span>
    //       Checking
    //     </button>
    //   ) : label ? (
    //     <input
    //       type="submit"
    //       value="See answers"
    //       class="btn border-primary text-primary fw-bold"
    //       {...props}
    //     />
    //   ) :
};

export default EditButton;